import stringHelpers from "../../utilities/stringHelpers"
import Loader from "../shared/loader"
export const CameraLastRead = ({ imageUrl, isLoading, onRefresh }) => {
    return (
        <div className='d-flex align-items-start'>
            { !stringHelpers.isNullOrEmpty(imageUrl)
                ? <img width="100%" src={ imageUrl } alt="Last camera read" />
                : <div className="d-flex flex-column align-items-center justify-content-center border rounded bg-200 text-500 flex-grow-1 last-read-placeholder">
                    {isLoading
                        ? <Loader />
                        : <>
                            <i className="fas fa-camera mb-2 fs-3"></i>
                            <small>No image available</small>
                          </>
                    }
                </div>
            }

            <button onClick={ onRefresh } className='btn btn-falcon-default ml-2'><i className='fas fa-sync'></i></button>
        </div>
    )
}